<template>
  <div>
    <v-snackbar v-if="successMessage" v-model="successMessage" :timeout="5000" color="success">
      {{ successMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="successMessage = false">
          Close
        </v-btn>
      </template>
    </v-snackbar>
    <v-snackbar v-if="errorMessage" v-model="errorMessage" :timeout="15000" color="error">
      {{ errorMessage }}

      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="errorMessage = false"> Close </v-btn>
      </template>
    </v-snackbar>
    <v-card color="basil" flat>
      <v-card-text>
        {{ caption }}
        <d-table
          v-if="tableReady"
          :isDraggable="isDraggable"
          v-bind="model.schema"
          :v-bind="model.schema"
          :key="compKey"
          :noRefreshAfterUpload="true"
          ref="dTable"
          :onDataReceived="onDataReceived"
          :coloredFields="coloredFields"
          :getItemColor="getItemColor"
          :itemsPerPage="50"
          :columnTool="true"
          :refreshAfterSubmit="refreshAfterSubmit"
          :editedItemTitle="editedItemTitle"
          :addButtonCaption="addButtonCaption"
          :tableName="tableName"
          :hideTitle="true"
          table_title=""
          tableHeight="52vh"
          :sortBy="sortBy"
          :copyRecords="copyRecords"
          :mainTabs="mainTabs"
          :beforeAddData="beforeAddData"
          :hasParent="true"
          :useTabs="useTabs"
        />
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import * as fun from "../plugins/common";
import axios from "axios";
// import ObjectId from "bson-objectid";
export default {
  name: "Settings",
  components: {
    DTable: () => import("../components/Table.vue")
  },
  props: {},
  data() {
    return {
      objectKey: "Settings",
      copyRecords: null,
      settings_name: "",
      model: {},
      sortBy: null,
      tableReady: false,
      compKey: 0,
      fieldsExcluded: [],
      addButtonCaption: "",
      onDataReceived: null,
      coloredFields: ["color"],
      serverPagination: false,
      newZoneRate: null,
      refreshAfterSubmit: false,
      addData: [],
      addSchema: [],
      editedItemTitle: [],
      tableName: "",
      isDraggable: false,
      mainTabs: [],
      currentCompany: null,
      zones: [],
      companies: [],
      allCompanies: [],
      zonaStructure: {},
      successMessage: "",
      errorMessage: "",
      zoneTbl: null,
      tableKey: 0,
      caption: "",
      zoneRates: [],
      originalCompanyZoneRates: [],
      editedRecord: null,
      tariffFiles: [],
      useTabs: false
    };
  },
  mounted() {
    var that = this;
    this.settings_name = this.$route.params.id;
    this.getSchema();
    this.$root.$on("tableEditRecord", (tbl, item) => {
      console.log(tbl);
      that.editedRecord = tbl.rec;
      if (tbl.rec && tbl.tbl.data_object.object_name == "company") {
        that.currentCompany = {
          _id: tbl.rec._id,
          company_name: tbl.rec.company_name
        };
      }
    });
    this.$root.$on("comboUpdated", function(obj) {
      if (obj.model && obj.ctlName == "comp") {
        that.currentCompany = obj.model._id;
        // that.caption = obj.model.company_name;
        that.companies = obj.obj.comboItems;
        that.getZones();
      }
    });

    this.$root.$on("get_combo_items", function(obj) {
      console.log(obj.ctlName);
      if (obj.ctlName == "file_name") {
        that.getTariffFiles(obj);
      }
    });
    //
    //rowAdded
    this.$root.$on("rowAdded", tbl => {
      if (tbl.tbl.tableName == "zone_rate") {
        // that.zoneTbl = tbl;
        // console.log(tbl.tbl.table);
        tbl.row.company_zone_rate = [{ company_id: that.currentCompany }];
        // if (tbl.tbl.table.length == 1) {
        //   tbl.tbl.applyRow();
        // }
      }
    });
    //initTable
    this.$root.$on("initTable", tbl => {
      if (tbl.tableName == "zone") {
        tbl.table.forEach(r => {
          if (!r.company) {
            //
          }
          //
        });
      }
    });
    this.$root.$on("tableMounted", tbl => {
      if (tbl.tableName == "zone") {
        that.zoneTbl = tbl;
      }
      if (tbl.tableName == "zone_rate") {
        tbl.toolBarControls[0]["v-bind"]["filter"] = function(b) {
          return b.company_id == that.currentCompany;
        };
      }
      if (tbl.tableName == "company_zone_rate") {
        console.log(tbl);
        that.originalCompanyZoneRates = fun.clone(tbl.table);
        if (that.currentCompany) {
          tbl.table = tbl.table.filter(t => {
            return t.company_id == that.currentCompany;
          });
        }
        if (tbl.table.length == 1) {
          // tbl.hideScroll = true;
        }

        // if (!curCompanyRate.length) {
        //   tbl.table.push({
        //     company_id: that.currentCompany,
        //   });
        // }

        // var parTable = fun.getParentByProperty(tbl, "tableName");
        // tbl.rowClassFn = function(item) {
        //   if (item.company_id != that.currentCompany) {
        //     return "hidden-row";
        //   }
        // };

        // that.loadZoneRates(tbl);
      }
    });

    this.$root.$on("onDemandLoaded", tbl => {
      if (tbl.tbl.tableName == "zone_rate") {
        this.loadZoneRates(tbl.data);
      }
    });

    this.$root.$on("customBtnClick", function(obj) {
      switch (obj.btn) {
        case "domain_instructions":
          window.open(
            "https://help.brevo.com/hc/en-us/articles/12163873383186-Authenticate-your-domain-Brevo-code-DKIM-DMARC"
          );

          break;
        case "add_domain":
          var frm = obj.frm;
          // var dns_records = {
          //   dkim_record: {
          //     type: "TXT",
          //     value:
          //       "k=rsa;p=MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQDeMVIzrCa3T14JsNY0IRv5/2V1/v2itlviLQBwXsa7shBD6TrBkswsFUToPyMRWC9tbR/5ey0nRBH0ZVxp+lsmTxid2Y2z+FApQ6ra2VsXfbJP3HE6wAO0YTVEJt1TmeczhEd2Jiz/fcabIISgXEdSpTYJhb0ct0VJRxcg4c8c7wIDAQAB",
          //     host_name: "mail._domainkey.",
          //     status: false,
          //   },
          //   brevo_code: {
          //     type: "TXT",
          //     value: "brevo-code:7d71be3f0f6f319ca9ae37bab5dcf55f",
          //     host_name: "",
          //     status: false,
          //   },
          // };
          // var addDnsRecords = function() {
          //   obj.frm.model.dns_records = [];
          //   Object.keys(dns_records).forEach((k) => {
          //     var dns = {
          //       _id: fun.guid(),
          //       name: k,
          //       type: dns_records[k].type,
          //       value: dns_records[k].value,
          //       host_name: dns_records[k].host_name,
          //     };

          //     obj.frm.model.dns_records.push(dns);
          //   });
          // };

          axios
            .post(
              this.serverURL + "/add_domain",
              { name: obj.frm.model.domain },
              {
                withCredentials: true
              }
            )
            .then(response => {
              var data = JSON.parse(response.data);
              if (data.domain_name) {
                obj.frm.model.authenticated = data.authenticated;
                obj.frm.model.added_to_brevo = true;
                obj.frm.$forceUpdate();
                that.$refs.dTable.validateAndSave(false, false, true);
              } else {
                if (data.message) {
                  if (data.message.includes("success")) {
                    that.successMessage = data.message;
                    // dns_records = data.dns_records;

                    // addDnsRecords();

                    //
                  } else {
                    that.errorMessage = data.message;
                  }
                } else {
                  that.errorMessage = data;
                }
              }

              console.log(response);
            });

          break;

        case "authenticate_domain":
          axios
            .post(
              this.serverURL + "/authenticate_domain",
              { name: obj.frm.model.domain },
              {
                withCredentials: true
              }
            )
            .then(response => {
              var data = response.data;
              if (data.domain_name) {
                if (data.message.includes("success")) {
                  obj.frm.model.authenticated = true;
                  that.successMessage = data.message;

                  // obj.frm.model.added_to_brevo = true;
                  obj.frm.$forceUpdate();
                  that.$refs.dTable.validateAndSave();
                }
              } else {
                if (data.message) {
                  if (data.message.includes("success")) {
                    that.successMessage = data.message;
                    // dns_records = data.dns_records;

                    // addDnsRecords();

                    //
                  } else {
                    that.errorMessage = data.message;
                  }
                } else {
                  that.errorMessage = data;
                }
              }

              console.log(response);
            });
          break;

        case "authorizeGmail":
          axios
            .post(
              this.serverURL + "/authorization_link",
              { email: obj.frm.model.user_email },
              {
                withCredentials: true
              }
            )
            .then(r => {
              window.open(r.data, "_blank");
            });
          break;
        case "update_zone":
          that.updateZoneRates();
          break;
        // case "share_rates":
        //   console.log(obj.btn);
        //   break;
        default:
          break;
      }
    });
    //labelBtnChanged
    this.$root.$on("labelBtnChanged", function(obj) {
      var tbl = that.$refs.dTable;

      switch (obj.obj.btnId) {
        case "copy_zones":
          // console.log(obj.btn);
          // console.log(that.zones);
          break;
        case "share_zones":
          // console.log(obj.btn);
          that.shareZones(obj);
          break;

        default:
          break;
      }
    });
    this.$root.$on("tableChanged", e => {
      // console.log(e);
    });
    this.$root.$on("tableItemChanged", e => {
      //
    });
  },
  activated() {
    // console.log("activated");
    // if (this.settings_name && this.settings_name != this.$route.params.id) {
    this.settings_name = this.$route.params.id;
    this.getSchema();
    // this.compKey = !this.compKey;
    // }
  },
  beforeDestroy() {},
  watch: {
    // $route: {
    //   handler: function() {
    //     this.settings_name = this.$route.params.id;
    //     this.getSchema();
    //     this.compKey = !this.compKey;
    //   },
    // },
  },
  methods: {
    beforeAddData(model, tbl) {
      // console.log(tbl);
      var that = this;
      if (tbl.tableName == "zone_rate") {
        model.zone_rate.forEach(r => {
          if (r.company_zone_rate.length < model.company.length) {
            console.log(r);
            var missingRate = that.originalCompanyZoneRates.filter(c => {
              return c.company_id != that.currentCompany;
            });
            if (missingRate.length) {
              missingRate.forEach(m => {
                r.company_zone_rate.push(m);
              });
            }
          }
        });
        //
      }
    },
    getZones() {
      // if (tbl.tableName == "zone" && that.currentCompany) {
      var that = this;
      var tbl = this.zoneTbl;
      if (tbl) {
        tbl.data_object.schema = this.zonaStructure;
        if (this.allCompanies.length < 2) {
          tbl.toolBarControls = [];
        } else {
          tbl.toolBarControls.forEach(c => {
            if (c.id == "share_zones" || c.id == "copy_zones") {
              var btn = tbl.$refs[c.id];

              if (btn) {
                btn = btn[0];
                btn.options = that.companies.filter(r => {
                  return r._id != that.currentCompany;
                });
                btn.options.forEach(o => {
                  o.text = o.company_name;
                  o.value = o._id;
                });
              }
              // c["v-bind"].schema.add_option_object["items"] = that.companies.filter(
              //   (r) => {
              //     return r._id != that.currentCompany;
              //   }
              // );
            }
          });
        }
      }

      // tbl.toolBarKey = !tbl.toolBarKey;
      this.loadZones();
      // }
      // if (tbl.tableName == "zone_rate" && that.currentCompany) {
      //   tbl.editData.forEach((r) => {
      //     r.company_zone_rate = r.company_zone_rate.filter((c) => {
      //       return c.company_id == this.currentCompany._id;
      //     });
      //   });
      // }
    },
    updateZoneRates() {
      var that = this;
      var data = {
        company_id: this.currentCompany._id
      };
      axios
        .post(this.serverURL + "/update_zone_rate", data, {
          withCredentials: true
        })
        .then(function(response) {
          if (response.data.msg) {
            that.successMessage = "successfully updated zones";
            that.loadZones(true);
            that.compKey = !that.compKey;
          }
        });
    },
    shareZones(company) {
      var that = this;
      // var zones = this.zoneTbl.originalRecords.filter((f) => {
      //   return (
      //     f.company &&
      //     f.company.some((c) => {
      //       return c._id == company.itemValue;
      //     })
      //   );
      // });
      // zones
      //   .filter((z) => {
      //     return z.company._id != that.currentCompany;
      //   })
      //   .forEach((z) => {
      //     z.company.push({ _id: that.currentCompany });
      //   });
      // zones.forEach((z) => {
      //   if (z.zone_rate && z.zone_rate.length) {
      //     z.zone_rate
      //       .filter((z) => {
      //         return z.company_id != this.currentCompany;
      //       })
      //       .forEach((r) => {
      //         var newCompRate = fun.clone(r);
      //         newCompRate.company_id = this.currentCompany;
      //         r.company_zone_rate.push(newCompRate);
      //       });
      //   }
      // });

      // var data = {
      //   metadata: { object_name: "zone" },
      //   model: zones,
      // };
      var data = {
        company_id: company.itemValue,
        new_company_id: this.currentCompany
      };
      axios
        .post(this.serverURL + "/share_zone", data, {
          withCredentials: true
        })
        .then(function(response) {
          if (response.data.msg) {
            that.successMessage = "successfully shared zones";
            that.loadZones(true);
            that.compKey = !that.compKey;
          }
        });
    },
    loadZones() {
      if (this.zoneTbl) {
        this.zoneTbl.table = this.zoneTbl.table.filter(z => {
          return (
            (z.company &&
              z.company.some(c => {
                return c._id == this.currentCompany;
              })) ||
            !z.company
          );
        });
      }
    },
    loadZoneRates(data) {
      data.forEach(r => {
        if (r.company_zone_rate) {
          r.company_zone_rate.forEach(z => {
            if (!z._id) {
              z._id = fun.guid();
            }
          });
        }

        // r.company_zone_rate = r.company_zone_rate.filter((c) => {
        //   return c.company_id == this.currentCompany;
        // });
      });
      this.zoneRates = data;
    },

    getItemColor(value, field, isItem) {
      if (field == "color") {
        return value;
      }
    },
    getTariffFiles(obj) {
      var files = obj.items;
      console.log(files);
      var dirs = [];
      this.editedRecord?.company?.forEach(c => {
        dirs.push({ object_name: c.collection, record_id: c._id });
        //
      });
      axios
        .post(
          this.serverURL + "/get_tariff_files",
          { dirs: dirs },
          {
            withCredentials: true
          }
        )
        .then(response => {
          files = response.data;
          obj.comboItems = files;
          // obj.$forceUpdate();
          console.log(obj.comboItems);
        });
    },
    getSchema() {
      var that = this;
      let title = fun.capitalize(this.settings_name);
      let object_name = "";
      let object_key = "";
      let insertable = true;
      let editRow = false;
      let alwaysAddId = false;
      let alwaysUpdate = true;
      let fieldsExcluded = [];
      let serverPagination = false;
      let defaultModel = null;
      this.useTabs = false;
      object_name = this.settings_name;
      switch (this.settings_name) {
        case "list_items":
          this.editedItemTitle = ["item_name"];
          insertable = false;
          alwaysAddId = true;

          this.addButtonCaption = "Add Item";
          title = "Item List";
          object_key = "item_name";
          this.sortBy = "item_name";
          defaultModel = {
            item_handling: {}
          };
          break;
        case "material_list":
          object_key = "material_name";
          this.tableName = "material_list";
          this.addData = [{ obj_name: "company" }];
          this.onDataReceived = function(data) {
            console.log(data);
            data.model.forEach(m => {
              if (!m.company) {
                m.company = data.additional_model.company;
              }
            });
            return data;
          };
          break;
        case "time_slot":
          object_key = "slot";
          break;
        // case "agent":
        //   insertable = false;
        //   alwaysAddId = true;
        //   title = "Agent";
        //   this.editedItemTitle = ["contact.first_name", "contact.last_name"];
        //   // fieldsExcluded = ["zones"];
        //   defaultModel = {
        //     contact: {},
        //     address: {},
        //     roles: [],
        //     brokers: [],
        //     zones: [],
        //   };
        //   // alwaysUpdate = true;
        //   break;
        // case "broker":
        //   insertable = false;
        //   alwaysAddId = true;
        //   title = "Broker";
        //   this.editedItemTitle = ["contact.first_name", "contact.last_name"];
        //   // alwaysUpdate = true;
        //   break;

        // case "employee":
        //   insertable = false;
        //   alwaysAddId = true;
        //   title = "Employee";
        //   fieldsExcluded = ["address"];
        //   this.editedItemTitle = ["contact.first_name", "contact.last_name"];
        //   defaultModel = {
        //     contact: {},
        //     address: {},
        //     roles: [],
        //   };
        //   this.onDataReceived = function(data) {
        //     data.model.forEach((d) => {
        //       if (!d.roles || !d.roles.length) {
        //         d.roles = [];
        //       }
        //     });
        //     return data;
        //   };
        //   break;

        case "company":
          insertable = false;
          alwaysAddId = true;
          this.addButtonCaption = "Add Company";
          this.editedItemTitle = ["company_name"];
          defaultModel = {
            address: {},
            email_setup: {},
            sms_setup: {},
            default_settings: {},
            cc_setup: {},
            phones: {
              office: { phone_type: "office" }
            }
          };

          this.onDataReceived = function(data) {
            data.model.forEach(c => {
              Object.keys(defaultModel).forEach(d => {
                if (!c[d]) {
                  c[d] = defaultModel[d];
                }
              });
            });
            return data;
          };
          break;
        case "building":
          insertable = false;
          alwaysAddId = true;
          defaultModel = {
            address: {},
            cert_insurance: {}
          };
          // alwaysUpdate = true;
          break;
        case "zone":
          insertable = false;
          alwaysAddId = true;
          fieldsExcluded = ["zone_rate"];
          this.addData = [{ obj_name: "company" }];
          this.refreshAfterSubmit = false;
          this.addButtonCaption = "Add Zone";
          this.copyRecords = {
            field_name: "zone_name"
          };
          defaultModel = {};
          this.tableName = "zone";
          this.editedItemTitle = ["zone_name"];
          this.onDataReceived = function(data) {
            data.table = data.model;
            that.allCompanies = data.additional_model.company;
            return data;
          };

          break;
        case "zone_rate":
          insertable = false;
          alwaysAddId = true;
          fieldsExcluded = ["to_zone_rates"];
          serverPagination = false;

          break;
        case "warehouse":
          insertable = true;
          alwaysAddId = true;

          break;
        case "lead_status":
          this.addData = [{ obj_name: "stage" }];
          this.onDataReceived = function(data) {
            data.table = data.model;
            return data;
          };
          break;
        case "delivery_status":
          this.tableName = "delivery_status";
          this.isDraggable = true;
          this.$root.$on("rowReordered", t => {
            if (t.$parent.tableName == "delivery_status") {
              that.reordered = t.$parent.table;
              that.reordered.forEach((r, i) => {
                r.sort_order = i + 1;
              });
            }
          });
          break;
        case "stage":
          this.isDraggable = true;
          this.$root.$on("rowReordered", t => {
            if (t.$parent.tableName == "stage") {
              that.reordered = t.$parent.table;
              that.reordered.forEach((r, i) => {
                r.sort_order = i + 1;
              });
            }
          });
          break;
        case "task":
          insertable = false;
          alwaysAddId = true;
          editRow = true;
          this.addButtonCaption = "Add " + this.settings_name;

          break;
        case "truck":
          insertable = false;
          alwaysAddId = true;
          editRow = true;
          this.addButtonCaption = "Add " + this.settings_name;

          break;
        case "document_type":
          this.useTabs = true;
          break;
        case "tariffs":
          insertable = true;
          alwaysAddId = false;
          editRow = true;
          object_name = "charge_list";
          this.useTabs = true;
          this.sortBy = "charge_category";
          // this.refreshAfterSubmit = true;

          this.addButtonCaption = "Add Charge";
          // fieldsExcluded = [
          //   "charge_calculation",
          //   "taxable",
          //   "min_charge",
          //   "unit",
          //   "rate",
          // ];
          defaultModel = {
            service_type: [],
            charge_calculation: {},
            rates: [{}]
          };
          this.addData = [{ obj_name: "charge_category" }];
          this.onDataReceived = function(data) {
            this.tariffFiles = data.schema.properties.charge_calculation.properties.file_name["v-bind"].items;
            // this.getFiles(files)
            if (
              !data.table.some(d => {
                return d.charge_category == "labor";
              })
            ) {
              data.table.push({
                charge_category: "labor",
                crew_charge: []
              });
            }

            return data;
          };
          break;
        case "itinerary_status":
          defaultModel = {
            action_when_changed: {}
          };
          this.onDataReceived = function(data) {
            data.table.forEach(d => {
              if (!d.action_when_changed) {
                d.action_when_changed = {};
              }
            });
            return data;
          };
          break;
        case "dashboard_settings":
          this.sortBy = ["row", "col"];
          break;
        default:
          break;
      }
      this.model = {
        name: this.settings_name,
        title: title,
        component: "DTable",
        schema: {
          table_title: "",
          defaultModel: defaultModel,
          dExcel: false,
          excelColumnWidth: "300px",
          getFreshData: true,
          allEditable: insertable,
          directEdit: false,
          insertable: insertable,
          hasSearch: true,
          serverPagination: serverPagination,
          // addButtonCaption: this.addButtonCaption || "Add " + title,
          alwaysUpdate: alwaysUpdate,
          editRow: !insertable || editRow,

          data_object: {
            fields_excluded: fieldsExcluded,
            object_name: object_name,
            object_key: object_key,
            title: title,
            all_records: true,
            hasSearch: true,
            alwaysAddId: alwaysAddId,
            additional_data: this.addData,
            additional_structure: this.addStructure
          }
        }
      };
      this.tableReady = true;
      // this.item_tabs.push(model);
      // this.$refs.tabs.onResize();
      // });
    }
  }
};
//        "filterTabsFn": "var p=[]; parTable.forEach((z)=>{p.push({caption:z.zone_name.toLowerCase().replace('zone','').trim(), name: 'to_zone_id', value: z._id})}); p",
</script>

<style lang="css" scoped></style>
